export const GET_PARTNER_NAMES = 'GET_PARTNER_NAMES'